export default "__VITE_ASSET__cm76cwt$__"